import { routes } from "../utlis/provider/routes.utlis";
import { ProviderLayout } from "../layouts/provider/App.js";
import Dashboard from "../views/provider/dashboard/Page.js";
import Jobs from "../views/provider/jobs/Page.js";
import LockedJob from "../views/provider/jobs/LockedJob.js";
import JobDetails from "../views/provider/jobs/Details.js";
import Message from "../views/provider/message/Page.js";
import CareNetwork from "../views/provider/care-network/Page.js";
import CareNetworkDetails from "../views/provider/care-network/Details.js";
import Calendar from "../views/provider/calendar/Page.js";
import Newsletter from "../views/provider/newsletter/Page.js";
import Advertisement from "../views/provider/advertisement/Page.js";
import AddAdvertisement from "../views/provider/advertisement/AddAds.js";
import AdvertisementPaymentSuccess from "../views/provider/advertisement/PaymentSuccess.js";
import AdvertisementPaymentError from "../views/provider/advertisement/PaymentError.js";
import AdvertisementDetails from "../views/provider/advertisement/Details.js";
import PostedAds from "../views/provider/advertisement/PostedAds.js";
import Profile from "../views/provider/profile/Page.js";
import NetworkDirectory from "../views/provider/network-directory/Page.js";
import SubscriptionPlan from "../views/provider/subscription-plan/Page.js";
import AboutUs from "../views/provider/more/AboutUs.js";
import PrivacyPolicy from "../views/provider/more/PrivacyPolicy.js";
import TermCondition from "../views/provider/more/TermCondition.js";
import JobPost from "../views/provider/care-network/JobPost.js";
import PostedJob from "../views/provider/care-network/PostedJob.js";
import PaymentSuccess from "../views/provider/jobs/PaymentSuccess.js";
import PaymentError from "../views/provider/jobs/PaymentError.js";
import PaymentPostSuccess from "../views/provider/care-network/PaymentSuccess.js";
import PaymentPostError from "../views/provider/care-network/PaymentError.js";
import SubscriptionPaymentSuccess from "../views/provider/subscription-plan/PaymentSuccess.js";
import SubscriptionPaymentError from "../views/provider/subscription-plan/PaymentError.js";
import ProviderDetail from "../views/provider/network-directory/ProviderDetail.js";
import TransactionHistory from "../views/provider/transaction/Page.js";
import Contact from "../views/provider/more/Contact.js";
import MatchedApplicant from "../views/provider/care-network/MatchedApplicant.js";
import UserChat from "../views/provider/message/UserChat.js";
import Rating from "../views/provider/more/Rating.js";
import ExpensesDashboard from "../views/provider/expenses/Dashboard.js";
import ExpensesCreate from "../views/provider/expenses/Create.js";
import ExpensesEdit from "../views/provider/expenses/Edit.js";
import List from "../views/provider/expenses/List.js";
import BudgetList from "../views/provider/expenses/BudgetList.js";
import CommunityDashboard from "../views/provider/community/Dashboard.js";
import Following from "../views/provider/community/Following.js";
import MyCommunity from "../views/provider/community/MyCommunity.js";
import CommunityDetail from "../views/provider/community/Details.js";
import PostDetails from "../views/provider/community/PostDetails.js";
import SuggestedList from "../views/provider/community/SuggestedList.js";
import ShareProfile from "../views/provider/community/ShareProfile.js";
import CouponList from "../views/provider/loyalty/CouponList.js";

var ProviderRoutes = [
    {
        path: routes.dashboard,
        layout: ProviderLayout,
        component: Dashboard
    },
    {
        path: routes.message,
        layout: ProviderLayout,
        component: Message
    },
    {
        path: routes.providerMessage,
        layout: ProviderLayout,
        component: UserChat
    },
    {
        path: routes.myJobs,
        layout: ProviderLayout,
        component: Jobs
    },
    {
        path: routes.paymentSuccess,
        layout: ProviderLayout,
        component: PaymentSuccess
    },
    {
        path: routes.paymentError,
        layout: ProviderLayout,
        component: PaymentError
    },
    {
        path: routes.lockedJobs,
        layout: ProviderLayout,
        component: LockedJob
    },
    {
        path: routes.jobDetails,
        layout: ProviderLayout,
        component: JobDetails
    },
    {
        path: routes.careNetwork,
        layout: ProviderLayout,
        component: CareNetwork
    },
    {
        path: routes.careNetworkDetails,
        layout: ProviderLayout,
        component: CareNetworkDetails
    },
    {
        path: routes.addPost,
        layout: ProviderLayout,
        component: JobPost
    },
    {
        path: routes.paymentPostSuccess,
        layout: ProviderLayout,
        component: PaymentPostSuccess
    },
    {
        path: routes.paymentPostError,
        layout: ProviderLayout,
        component: PaymentPostError
    },
    {
        path: routes.postedJob,
        layout: ProviderLayout,
        component: PostedJob
    },
    {
        path: routes.matchedApplicant,
        layout: ProviderLayout,
        component: MatchedApplicant
    },
    {
        path: routes.advertisement,
        layout: ProviderLayout,
        component: Advertisement
    },
    {
        path: routes.addAdvertisement,
        layout: ProviderLayout,
        component: AddAdvertisement
    },
    {
        path: routes.advertisementPaymentSuccess,
        layout: ProviderLayout,
        component: AdvertisementPaymentSuccess
    },
    {
        path: routes.advertisementPaymentError,
        layout: ProviderLayout,
        component: AdvertisementPaymentError
    },
    {
        path: routes.postedAdvertisement,
        layout: ProviderLayout,
        component: PostedAds
    },
    {
        path: routes.advertisementDetails,
        layout: ProviderLayout,
        component: AdvertisementDetails
    },
    {
        path: routes.networkDirectory,
        layout: ProviderLayout,
        component: NetworkDirectory
    },
    {
        path: routes.userDetail,
        layout: ProviderLayout,
        component: ProviderDetail
    },
    {
        path: routes.calendar,
        layout: ProviderLayout,
        component: Calendar
    },
    {
        path: routes.newsletter,
        layout: ProviderLayout,
        component: Newsletter
    },
    {
        path: routes.profile,
        layout: ProviderLayout,
        component: Profile
    },
    {
        path: routes.transactionList,
        layout: ProviderLayout,
        component: TransactionHistory
    },
    {
        path: routes.subscriptionPlan,
        layout: ProviderLayout,
        component: SubscriptionPlan
    },
    {
        path: routes.subscriptionPaymentSuccess,
        layout: ProviderLayout,
        component: SubscriptionPaymentSuccess
    },
    {
        path: routes.subscriptionPaymentError,
        layout: ProviderLayout,
        component: SubscriptionPaymentError
    },
    {
        path: routes.aboutUs,
        layout: ProviderLayout,
        component: AboutUs
    },
    {
        path: routes.privacyPolicy,
        layout: ProviderLayout,
        component: PrivacyPolicy
    },
    {
        path: routes.termsCondition,
        layout: ProviderLayout,
        component: TermCondition
    },
    {
        path: routes.contactUs,
        layout: ProviderLayout,
        component: Contact
    },
    {
        path: routes.reviewList,
        layout: ProviderLayout,
        component: Rating
    },
    {
        path: routes.expenseDashboard,
        layout: ProviderLayout,
        component: ExpensesDashboard
    },
    {
        path: routes.expenseCreate,
        layout: ProviderLayout,
        component: ExpensesCreate
    },
    {
        path: routes.expenseEdit,
        layout: ProviderLayout,
        component: ExpensesEdit
    },
    {
        path: routes.expenseList,
        layout: ProviderLayout,
        component: List
    },
    {
        path: routes.budgetList,
        layout: ProviderLayout,
        component: BudgetList
    },
    {
        path: routes.communityDashboard,
        layout: ProviderLayout,
        component: CommunityDashboard
    },
    {
        path: routes.communitySuggested,
        layout: ProviderLayout,
        component: SuggestedList
    },
    {
        path: routes.communityFollowing,
        layout: ProviderLayout,
        component: Following
    },
    {
        path: routes.communityList,
        layout: ProviderLayout,
        component: MyCommunity
    },
    {
        path: routes.communityInfo,
        layout: ProviderLayout,
        component: CommunityDetail
    },
    {
        path: routes.communityPostInfo,
        layout: ProviderLayout,
        component: PostDetails
    },
    {
        path: routes.communityShareProfile,
        layout: ProviderLayout,
        component: ShareProfile
    },
    {
        path: routes.careLoyalty,
        layout: ProviderLayout,
        component: CouponList
    },
];

export default ProviderRoutes;